const fillArray = (value, len) => {
  let arr = [];
  for (let i = 0; i < len; i++) {
    arr.push(value);
  }
  return arr;
}

export default fillArray;
